import type { ComponentType, ReactNode } from "react";

import { styled } from "styled-components";

import { IconButton, TabPanel, Tabs } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

import { integrationMaxWidth, integrationMinWidth } from "../../../manage-export/style";

export const StyledTeamDetailContainer = styled(Stack)`
    ${integrationMaxWidth};
    ${integrationMinWidth};
    gap: 32px;
    margin: 0 auto 24px;
    flex: 1;
    min-height: 0;
`;

export const StyledTeamActionButton = styled(IconButton)`
    flex: none;
`;

type TeamDetailTabsProps = {
    selectedIndex: number;
    onSelect?: (index: number) => void;
    children?: ReactNode;
};

const TeamDetailTabs = Tabs as ComponentType<TeamDetailTabsProps>;

export const StyledTeamDetailTabs = styled(TeamDetailTabs)`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
`;

type TeamDetailTabPanelProps = {
    selected?: boolean;
    forceRender?: boolean;
    children?: ReactNode;
    "data-automation"?: string;
    "data-automation-selected"?: boolean;
};

const TeamDetailTabPanel = TabPanel as ComponentType<TeamDetailTabPanelProps>;

export const StyledTeamDetailTabPanel = styled(TeamDetailTabPanel).attrs<
    Pick<TeamDetailTabPanelProps, "data-automation-selected">
>(({ selected }) => ({
    "data-automation-selected": selected === true,
}))`
    min-height: 0;

    &.selected {
        display: flex;
        flex-direction: column;
        flex: 1;
    }
`;

export const StyledScrollableTeamDetailTabPanel = styled(StyledTeamDetailTabPanel)`
    &.selected {
        overflow-x: hidden;
        overflow-y: auto;
    }
`;
